import { createORPCClient, onError, ORPCError } from '@orpc/client';
import type { ContractRouterClient } from '@orpc/contract';
import { OpenAPILink } from '@orpc/openapi-client/fetch';
import { fuelBenchmarkContract } from 'fuel-benchmark-contracts';
import { resolveApiBaseUrl } from '../env-config';
import { authTokenStore } from './auth-token';

export const LOGIN_PATH = '/login';

export const isUnauthorizedError = (error: unknown): boolean => error instanceof ORPCError && error.status === 401;

/** Drops the stored session and bounces the browser to `/login` — unless we are already there. */
const endSession = (): void => {
  authTokenStore.clear();

  if (window.location.pathname !== LOGIN_PATH) {
    window.location.replace(LOGIN_PATH);
  }
};

const link = new OpenAPILink(fuelBenchmarkContract, {
  url: resolveApiBaseUrl(),
  headers: () => {
    const accessToken = authTokenStore.getAccessToken();

    return accessToken ? { authorization: `Bearer ${accessToken}` } : {};
  },
  interceptors: [
    onError((error: unknown) => {
      if (isUnauthorizedError(error)) {
        endSession();
      }
    }),
  ],
});

export const orpcClient: ContractRouterClient<typeof fuelBenchmarkContract> = createORPCClient(link);
